import React from "react";
import submit from "submit-form";
import DropdownIcons from "../../../../parts/inputs/dropdown-icons";

const HeaderTemplates = ({ referAsClients, tabState, setTabState }) => {
  const descriptionText =
    tabState === "programs-tab"
      ? `Build training program templates to save time when sharing programs between ${
          referAsClients ? "clients" : "athletes"
        } and groups`
      : `Build meal plan templates to save time when repurposing plans between ${
          referAsClients ? "clients" : "athletes"
        } and groups`;

  const sortItems = [
    {
      title: "Date Added",
      src: "/img/svg/arrow-to-bottom.svg",
      alt: "createdDate",
      className: "icon-white",
      id: "createdDate",
    },
    {
      title: "A-Z",
      src: "/img/svg/sort-amount-up.svg",
      alt: "name",
      className: "icon-white",
      id: "name",
    },
    {
      title: "Z-A",
      src: "/img/svg/sort-amount-down.svg",
      alt: "nameDescending",
      className: "icon-white",
      id: "nameDescending",
    },
  ];

  const AddButton = ({ classNames, text }) => {
    const urlBase = `/actions/refresh/?modal[type]=`;
    const finalUrl =
      tabState === "programs-tab"
        ? `${urlBase}build-step-one&cycleType=new&isTemplate=true`
        : `${urlBase}handle-meal-plan`;
    return (
      <a
        className={classNames}
        role="button"
        data-button-type="primary"
        href={finalUrl}
      >
        <img src="/img/new-icons/add.svg" alt="add icon" />
        {text}
      </a>
    );
  };

  return (
    <header className="header-coaching-programs">
      <hgroup className="hgroup-templates">
        <div className="header-text">
          <h3>Templates</h3>
          <p className="p4 opacity-70">{descriptionText}</p>
        </div>
        {tabState === "meal-plans-tab" && (
          <a
            role="button"
            data-button-type="outline"
            href="/coaching-portal/master-food-library"
          >
            Master Food Library
          </a>
        )}
      </hgroup>
      <nav role="tablist">
        <div>
          <a
            id="programs-tab"
            onClick={() => setTabState("programs-tab")}
            aria-current={tabState === "programs-tab" ? true : undefined}
          >
            Programs
          </a>
          <a
            id="meal-plans-tab"
            onClick={() => setTabState("meal-plans-tab")}
            aria-current={tabState === "meal-plans-tab" ? true : undefined}
          >
            Meal Plans
          </a>
        </div>
        <hgroup>
          <DropdownIcons
            title="Sort"
            items={sortItems}
            action={(sort) => {
              submit(`/actions/refresh`, {
                method: "GET",
                body: { sort },
              });
            }}
          />
          <AddButton classNames="force-mobile-hidden" text="Add New" />
          <AddButton classNames="force-only-show-mobile" text="Add New" />
        </hgroup>
      </nav>
    </header>
  );
};

export default HeaderTemplates;
